import React, { FC, memo } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import {
  NextBestActionDefinitionAction,
  NextBestActionType,
} from "../../../../projection/nextBestActionDefinition/nextBestActionDefinition";
import { nextBestActionDefinitionHasChildren } from "../../../../projection/nextBestActionDefinition/nextBestActionDefinition.typeguards";
import { useNextBestActionItem } from "./behaviours/useNextBestActionItem";
import { NextBestActionLayout } from "./components/nextBestActionLayout/NextBestActionLayout";

interface NextBestActionProps {
  readonly action: NextBestActionDefinitionAction<NextBestActionType>;
  readonly basePath: string;
  readonly country: Country;
  readonly segment: Segment;
}

const NextBestAction: FC<NextBestActionProps> = ({ action, basePath, country, segment }) => {
  const Item = useNextBestActionItem({ type: action.type });

  return (
    <Item action={action} basePath={basePath} country={country} segment={segment}>
      {nextBestActionDefinitionHasChildren(action) && (
        <NextBestActionLayout action={action} basePath={basePath} country={country} segment={segment} />
      )}
    </Item>
  );
};

const memorizedNextBestAction = memo(NextBestAction);

export { memorizedNextBestAction as NextBestAction };
